import React from "react";
import { MainLayout } from "../../components/Layout";
import Headline from "../../components/Headline";
import LinkButton from "../../components/LinkButton";
import { URL_PATHS } from "../../routes";
import "./styles.scss";

const WithdrawalApplyFinish = () => (
    <MainLayout>
        <Headline>退会申請の受付完了</Headline>
        <div className="widhdrawal-apply-finish">
            <h3>退会申請を受け付けました</h3>
            <p>
                運営事務局による確認後
                <br />
                退会を処理させていただきます。
            </p>

            <p>完了後メールでご連絡させていただきます。</p>

            <p>
                退会に関するお問い合わせ
                <br />
                <a href="mailto:info@p-a.app">info@p-a.app</a>
            </p>
        </div>
        <LinkButton to={URL_PATHS.myPage()} color="primary">
            マイページへ
        </LinkButton>
    </MainLayout>
);
export default WithdrawalApplyFinish;
